import { apiCorporations } from '@/api/api-corporations.js'
import optionsToQuery from '@/utils/common.js'

const corporationsMutations = {
  corporations_set(state, corporations){
    state.corporations = corporations;
  },

  corporation_insert(state, corporation){
    state.corporations.items = [...state.corporations.items, corporation];
  },

  corporation_extract(state, corporation){
    state.corporations.items = state.corporations.items.map(item => item.id !== corporation.id)
  },

  corporations_update(state, corporation){
    state.corporations.items = state.corporations.items.map(item => item.id == corporation.id ? corporation : item)
  }
}

const corporationsActions = {
  async corporations_list({commit}, payload){
    let query;
    if(payload){
      query = optionsToQuery(payload);
    }
    const result = await apiCorporations.list(query);
    commit('corporations_set', result);
  },

  async corporation_by_id({commit}, payload){
    const result = await apiCorporations.get(payload);
    commit('corporation_insert', result);
    return result;
  },

  async corporation_create({commit}, payload){
    const result = await apiCorporations.create(payload);
    commit('corporation_insert', result);
  },

  async corporation_update({commit}, payload){
    const result = await apiCorporations.update(payload);
    commit('corporations_update', result);
  },

  async corporation_deactivate({commit}, payload){
    const result = await apiCorporations.deactivate(payload);
    commit('corporations_update', result);
  },

  async corporation_delete({commit}, payload){
    commit('corporation_extract', payload);
    await apiCorporations.delete(payload);
  },

  async corporation_search({commit}, payload){
    let query;
    if(payload){
      query = optionsToQuery(payload.options);
    }
    const result = await apiCorporations.search(payload.query, query);
    commit('corporations_set', result)
  }
}

export {
  corporationsActions,
  corporationsMutations
}